
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, EffectFade, Lazy } from "swiper";
require("swiper/swiper.less");
require("swiper/components/effect-fade/effect-fade.less");
require("swiper/components/lazy/lazy.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Autoplay, EffectFade, Lazy]);
export default defineComponent({
  components: {
    slideInfo,
    ...SWIPER_COMPONENTS
  },

  data() {
    return {
      imgList: [
        'https://mm2015.mamalaile.com.cn/413df99c0435ec4a9d7c3d5facaf17bc.jpg',
        'https://mm2015.mamalaile.com.cn/c91543e6d7b915abe1a58cc6506a73ba.jpg',
        'https://mm2015.mamalaile.com.cn/09a8c8b5fcf6c2748e2906b6ea601ff0.jpg',
        'https://mm2015.mamalaile.com.cn/8de2b883c03583e47e02c06f5bf5eb50.jpg',
      ],
      decorateList: [
        { position: 'bottom-left', url: require('/src/assets/images/home_pic2_bg@2x.png'), width: 28.07 },
      ]
    };
  }
});
